export default {
  api:
    process.env.REACT_APP_ENV === 'development' ? 'http://localhost:3001' : '',

  paidCompanyColumnSize: {
    copy: 50,
    id: 200,
    name: 150,
    companyName: 200,
    email: 200,
    internalDomain: 100,
    domainWorking: 100,
    logoAdded: 100,
    planType: 100,
    paymentMode: 120,
    lastOpened: 120
  }
};



// WEBPACK FOOTER //
// ./src/config/appConfig.js